// Public legal content. No invented registration numbers, addresses, phone numbers or officer names.
// The legal contact address is configuration-driven (settings.legal_contact_email / LEGAL_CONTACT_EMAIL).

const legal = {
  fr: {
    privacy: {
      title: "Politique de confidentialité",
      kicker: "Confidentialité",
      updated: "Dernière mise à jour",
      lead:
        "Cette politique explique quels renseignements Consultants Sparks recueille lorsque vous utilisez cette plateforme, pourquoi nous les recueillons et comment ils sont utilisés.",
      sections: [
        {
          title: "Renseignements que nous recueillons",
          items: [
            "Renseignements de compte : prénom, nom, adresse courriel, mot de passe (stocké uniquement sous forme de hachage), langue préférée.",
            "Renseignements de candidature : coordonnées, ville, province ou État, pays, confirmation d'âge (18 ans ou plus), expérience, disponibilité, mobilité, domaines d'intérêt, objectifs et motivation.",
            "Renseignements de profil : mises à jour que vous effectuez vous-même dans votre portail.",
            "Documents : curriculum vitæ et attestations que vous choisissez de téléverser.",
            "Renseignements de processus : étape de votre dossier, historique des étapes, notes internes et suivis créés par notre équipe.",
            "Renseignements de consentement : date et heure du consentement, version du consentement, consentement marketing distinct.",
            "Renseignements techniques et de sécurité : données minimales nécessaires à la sécurité du compte, à la limitation des abus et à la journalisation d'audit.",
          ],
        },
        {
          title: "Pourquoi nous utilisons ces renseignements",
          items: [
            "Traiter et évaluer votre candidature.",
            "Gérer la relation avec les personnes qui souhaitent développer un parcours professionnel avec nous.",
            "Communiquer avec vous au sujet de votre dossier.",
            "Assurer la sécurité de votre compte et prévenir les abus.",
            "Opérer nos activités de recrutement et de développement de projets.",
            "Administrer la plateforme et respecter nos obligations internes.",
          ],
        },
        {
          title: "Renseignements internes",
          body:
            "Certaines informations liées au processus (notes internes, commentaires d'équipe, relations d'affaires, affectations) sont strictement internes. Elles ne sont pas publiques et ne sont pas visibles dans le portail des candidats. Les noms d'organisations, de partenaires, de courtiers ou de réseaux avec lesquels nous entretenons des relations demeurent confidentiels par défaut et ne sont jamais publiés sans autorisation explicite.",
        },
        {
          title: "Consentement",
          body:
            "Le consentement au traitement de votre candidature est distinct du consentement aux communications marketing. Le consentement marketing est facultatif, n'est jamais coché à l'avance et peut être retiré à tout moment depuis votre portail.",
        },
        {
          title: "Conservation et accès",
          body:
            "Nous conservons les renseignements aussi longtemps que nécessaire aux fins décrites ci-dessus. L'accès interne est limité par rôle : un recruteur n'accède qu'aux dossiers qui lui sont attribués. Vos documents ne sont jamais accessibles publiquement.",
        },
        {
          title: "Vos demandes",
          body:
            "Vous pouvez demander l'accès à vos renseignements, leur correction ou leur suppression, ou retirer votre consentement marketing, en écrivant à l'adresse ci-dessous.",
        },
        {
          title: "Limites",
          body:
            "Cette politique décrit nos pratiques actuelles. Elle ne constitue pas un avis juridique et ne prétend pas établir automatiquement la conformité à une législation particulière. Elle peut être mise à jour ; la version en vigueur est celle publiée sur cette page.",
        },
      ],
      contactTitle: "Nous joindre au sujet de la confidentialité",
    },
    terms: {
      title: "Conditions d'utilisation",
      kicker: "Conditions",
      updated: "Dernière mise à jour",
      lead:
        "Ces conditions encadrent l'utilisation de la plateforme Consultants Sparks. En utilisant la plateforme, vous acceptez ces conditions.",
      sections: [
        {
          title: "Utilisation de la plateforme",
          body:
            "La plateforme permet de découvrir des catégories d'opportunités, de soumettre une candidature générale et de suivre l'évolution de votre dossier. Elle est destinée à un usage personnel et professionnel légitime.",
        },
        {
          title: "Votre compte",
          body:
            "Vous êtes responsable de la confidentialité de vos identifiants et de toute activité effectuée à partir de votre compte. Vous devez avoir 18 ans ou plus pour soumettre une candidature.",
        },
        {
          title: "Exactitude des renseignements",
          body:
            "Vous vous engagez à fournir des renseignements exacts et à jour. Des renseignements inexacts peuvent empêcher le traitement de votre dossier.",
        },
        {
          title: "Usage acceptable",
          items: [
            "Ne pas soumettre de contenu illégal, trompeur ou frauduleux.",
            "Ne pas tenter d'accéder à des données qui ne vous appartiennent pas.",
            "Ne pas contourner les mesures de sécurité, de limitation ou d'authentification.",
            "Ne pas utiliser la plateforme pour envoyer des communications non sollicitées.",
          ],
        },
        {
          title: "Propriété intellectuelle",
          body:
            "La marque, les contenus, les textes et les éléments visuels de la plateforme appartiennent à Consultants Sparks ou à ses ayants droit et ne peuvent être reproduits sans autorisation.",
        },
        {
          title: "Disponibilité des opportunités",
          body:
            "Les catégories présentées sont indicatives. Elles ne constituent pas des offres publiées et peuvent évoluer ou ne pas être disponibles.",
        },
        {
          title: "Aucune garantie",
          items: [
            "Aucune garantie d'emploi.",
            "Aucune garantie de placement.",
            "Aucune garantie de revenu.",
            "Aucune garantie d'avancement, de progression ou d'obtention d'un permis ou d'une accréditation.",
          ],
        },
        {
          title: "Relations avec des tiers",
          body:
            "Certaines opportunités peuvent impliquer des organisations tierces. Consultants Sparks n'est pas automatiquement l'employeur pour chaque opportunité et n'est pas responsable des décisions, conditions ou pratiques de tiers.",
        },
        {
          title: "Limitation",
          body:
            "La plateforme est fournie telle quelle, sans garantie de disponibilité continue. Dans les limites permises par la loi applicable, Consultants Sparks ne peut être tenue responsable des dommages indirects liés à l'utilisation de la plateforme.",
        },
        {
          title: "Suspension et résiliation",
          body:
            "Nous pouvons suspendre ou fermer un compte en cas de manquement à ces conditions, d'usage abusif ou de risque pour la sécurité de la plateforme.",
        },
        {
          title: "Modification des conditions",
          body:
            "Ces conditions peuvent être modifiées. La version en vigueur est celle publiée sur cette page.",
        },
      ],
      contactTitle: "Questions concernant ces conditions",
    },
  },

  en: {
    privacy: {
      title: "Privacy Notice",
      kicker: "Privacy",
      updated: "Last updated",
      lead:
        "This notice explains what information Consultants Sparks collects when you use this platform, why we collect it and how it is used.",
      sections: [
        {
          title: "Information we collect",
          items: [
            "Account information: first name, last name, email address, password (stored only as a hash), preferred language.",
            "Application information: contact details, city, province or state, country, age confirmation (18 or older), experience, availability, mobility, areas of interest, goals and motivation.",
            "Profile information: updates you make yourself in your portal.",
            "Documents: résumé and certifications you choose to upload.",
            "Process information: your file stage, stage history, internal notes and follow-ups created by our team.",
            "Consent information: consent timestamp, consent version, separate marketing consent.",
            "Technical and security information: the minimum data required for account security, abuse limiting and audit logging.",
          ],
        },
        {
          title: "Why we use this information",
          items: [
            "To process and evaluate your application.",
            "To manage the relationship with people building a professional path with us.",
            "To communicate with you about your file.",
            "To secure your account and prevent abuse.",
            "To operate our recruitment and project development activities.",
            "To administer the platform and meet our internal obligations.",
          ],
        },
        {
          title: "Internal information",
          body:
            "Some process-related information (internal notes, team comments, business relationships, assignments) is strictly internal. It is not public and is not visible in the candidate portal. Names of organizations, partners, brokers or networks we maintain relationships with remain confidential by default and are never published without explicit approval.",
        },
        {
          title: "Consent",
          body:
            "Consent to process your application is separate from consent to marketing communications. Marketing consent is optional, never pre-checked, and can be withdrawn at any time from your portal.",
        },
        {
          title: "Retention and access",
          body:
            "We keep information for as long as necessary for the purposes described above. Internal access is limited by role: a recruiter only accesses the files assigned to them. Your documents are never publicly accessible.",
        },
        {
          title: "Your requests",
          body:
            "You may request access to your information, its correction or deletion, or withdraw marketing consent, by writing to the address below.",
        },
        {
          title: "Limits",
          body:
            "This notice describes our current practices. It is not legal advice and does not automatically claim compliance with any specific legislation. It may be updated; the version in force is the one published on this page.",
        },
      ],
      contactTitle: "Contact us about privacy",
    },
    terms: {
      title: "Terms of Use",
      kicker: "Terms",
      updated: "Last updated",
      lead:
        "These terms govern the use of the Consultants Sparks platform. By using the platform, you accept these terms.",
      sections: [
        {
          title: "Use of the platform",
          body:
            "The platform lets you discover opportunity categories, submit a general application and follow the progress of your file. It is intended for legitimate personal and professional use.",
        },
        {
          title: "Your account",
          body:
            "You are responsible for keeping your credentials confidential and for all activity carried out from your account. You must be 18 or older to submit an application.",
        },
        {
          title: "Accuracy of information",
          body:
            "You agree to provide accurate and up-to-date information. Inaccurate information may prevent your file from being processed.",
        },
        {
          title: "Acceptable use",
          items: [
            "Do not submit unlawful, misleading or fraudulent content.",
            "Do not attempt to access data that does not belong to you.",
            "Do not bypass security, rate-limiting or authentication measures.",
            "Do not use the platform to send unsolicited communications.",
          ],
        },
        {
          title: "Intellectual property",
          body:
            "The brand, content, text and visual elements of the platform belong to Consultants Sparks or its rights holders and may not be reproduced without permission.",
        },
        {
          title: "Availability of opportunities",
          body:
            "The categories presented are indicative. They are not published postings and may change or be unavailable.",
        },
        {
          title: "No guarantees",
          items: [
            "No guarantee of employment.",
            "No guarantee of placement.",
            "No guarantee of income.",
            "No guarantee of advancement, progression, licensing or accreditation.",
          ],
        },
        {
          title: "Third-party relationships",
          body:
            "Some opportunities may involve third-party organizations. Consultants Sparks is not automatically the employer for every opportunity and is not responsible for the decisions, conditions or practices of third parties.",
        },
        {
          title: "Limitation",
          body:
            "The platform is provided as is, without any guarantee of continuous availability. To the extent permitted by applicable law, Consultants Sparks is not liable for indirect damages arising from use of the platform.",
        },
        {
          title: "Suspension and termination",
          body:
            "We may suspend or close an account in the event of a breach of these terms, abusive use or a risk to platform security.",
        },
        {
          title: "Changes to these terms",
          body: "These terms may be amended. The version in force is the one published on this page.",
        },
      ],
      contactTitle: "Questions about these terms",
    },
  },

  es: {
    privacy: {
      title: "Aviso de privacidad",
      kicker: "Privacidad",
      updated: "Última actualización",
      lead:
        "Este aviso explica qué información recopila Consultants Sparks cuando utiliza esta plataforma, por qué la recopila y cómo se utiliza.",
      sections: [
        {
          title: "Información que recopilamos",
          items: [
            "Información de la cuenta: nombre, apellido, correo electrónico, contraseña (almacenada únicamente como hash), idioma preferido.",
            "Información de la candidatura: datos de contacto, ciudad, provincia o estado, país, confirmación de edad (18 años o más), experiencia, disponibilidad, movilidad, ámbitos de interés, objetivos y motivación.",
            "Información del perfil: actualizaciones que usted realiza en su portal.",
            "Documentos: currículum y certificaciones que decida cargar.",
            "Información del proceso: etapa de su expediente, historial de etapas, notas internas y seguimientos creados por nuestro equipo.",
            "Información de consentimiento: fecha y hora del consentimiento, versión del consentimiento, consentimiento de marketing separado.",
            "Información técnica y de seguridad: los datos mínimos necesarios para la seguridad de la cuenta, la limitación de abusos y el registro de auditoría.",
          ],
        },
        {
          title: "Por qué utilizamos esta información",
          items: [
            "Tramitar y evaluar su candidatura.",
            "Gestionar la relación con las personas que construyen una trayectoria profesional con nosotros.",
            "Comunicarnos con usted sobre su expediente.",
            "Proteger la seguridad de su cuenta y prevenir abusos.",
            "Operar nuestras actividades de reclutamiento y desarrollo de proyectos.",
            "Administrar la plataforma y cumplir con nuestras obligaciones internas.",
          ],
        },
        {
          title: "Información interna",
          body:
            "Parte de la información del proceso (notas internas, comentarios del equipo, relaciones comerciales, asignaciones) es estrictamente interna. No es pública ni visible en el portal del candidato. Los nombres de organizaciones, socios, corredores o redes con los que mantenemos relaciones permanecen confidenciales por defecto y nunca se publican sin autorización explícita.",
        },
        {
          title: "Consentimiento",
          body:
            "El consentimiento para tramitar su candidatura es distinto del consentimiento para comunicaciones de marketing. El consentimiento de marketing es opcional, nunca está marcado previamente y puede retirarse en cualquier momento desde su portal.",
        },
        {
          title: "Conservación y acceso",
          body:
            "Conservamos la información durante el tiempo necesario para los fines descritos. El acceso interno está limitado por rol: un reclutador solo accede a los expedientes que le han sido asignados. Sus documentos nunca son accesibles públicamente.",
        },
        {
          title: "Sus solicitudes",
          body:
            "Puede solicitar el acceso a su información, su corrección o eliminación, o retirar el consentimiento de marketing, escribiendo a la dirección indicada a continuación.",
        },
        {
          title: "Límites",
          body:
            "Este aviso describe nuestras prácticas actuales. No constituye asesoramiento jurídico ni afirma automáticamente el cumplimiento de una legislación concreta. Puede actualizarse; la versión vigente es la publicada en esta página.",
        },
      ],
      contactTitle: "Contáctenos sobre privacidad",
    },
    terms: {
      title: "Términos de uso",
      kicker: "Términos",
      updated: "Última actualización",
      lead:
        "Estos términos rigen el uso de la plataforma Consultants Sparks. Al utilizar la plataforma, usted acepta estos términos.",
      sections: [
        {
          title: "Uso de la plataforma",
          body:
            "La plataforma permite descubrir categorías de oportunidades, enviar una candidatura general y seguir la evolución de su expediente. Está destinada a un uso personal y profesional legítimo.",
        },
        {
          title: "Su cuenta",
          body:
            "Usted es responsable de la confidencialidad de sus credenciales y de toda actividad realizada desde su cuenta. Debe tener 18 años o más para enviar una candidatura.",
        },
        {
          title: "Exactitud de la información",
          body:
            "Se compromete a proporcionar información exacta y actualizada. La información inexacta puede impedir la tramitación de su expediente.",
        },
        {
          title: "Uso aceptable",
          items: [
            "No enviar contenido ilícito, engañoso o fraudulento.",
            "No intentar acceder a datos que no le pertenecen.",
            "No eludir las medidas de seguridad, limitación o autenticación.",
            "No utilizar la plataforma para enviar comunicaciones no solicitadas.",
          ],
        },
        {
          title: "Propiedad intelectual",
          body:
            "La marca, los contenidos, los textos y los elementos visuales de la plataforma pertenecen a Consultants Sparks o a sus titulares de derechos y no pueden reproducirse sin autorización.",
        },
        {
          title: "Disponibilidad de oportunidades",
          body:
            "Las categorías presentadas son indicativas. No constituyen ofertas publicadas y pueden cambiar o no estar disponibles.",
        },
        {
          title: "Sin garantías",
          items: [
            "Sin garantía de empleo.",
            "Sin garantía de colocación.",
            "Sin garantía de ingresos.",
            "Sin garantía de promoción, progresión, licencia o acreditación.",
          ],
        },
        {
          title: "Relaciones con terceros",
          body:
            "Algunas oportunidades pueden implicar organizaciones de terceros. Consultants Sparks no es automáticamente el empleador de cada oportunidad y no es responsable de las decisiones, condiciones o prácticas de terceros.",
        },
        {
          title: "Limitación",
          body:
            "La plataforma se proporciona tal cual, sin garantía de disponibilidad continua. En la medida permitida por la ley aplicable, Consultants Sparks no será responsable de daños indirectos derivados del uso de la plataforma.",
        },
        {
          title: "Suspensión y terminación",
          body:
            "Podemos suspender o cerrar una cuenta en caso de incumplimiento de estos términos, uso abusivo o riesgo para la seguridad de la plataforma.",
        },
        {
          title: "Modificación de los términos",
          body: "Estos términos pueden modificarse. La versión vigente es la publicada en esta página.",
        },
      ],
      contactTitle: "Preguntas sobre estos términos",
    },
  },
};

export const LEGAL_PATHS = {
  privacy: { fr: "/confidentialite", en: "/privacy", es: "/privacidad" },
  terms: { fr: "/conditions", en: "/terms", es: "/terminos" },
};

export default legal;
